import { Pipe, PipeTransform } from '@angular/core';
import { element } from 'protractor';

@Pipe({
  name: 'dateFormater'
})
export class DateFormaterPipe implements PipeTransform {

  transform(value: string): any {
    if(value === null) return;

    let ArrayMeses: Array<string> = value.split('-');
    ArrayMeses = ArrayMeses.map((element: string) => {
      return this.labelMes(element);
    });

    return ArrayMeses.join('-');
  }

  labelMes = (mes) => {
    let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
    ];
    return meses[mes - 1];
  }

}
